<section class="card">
    <div class="card-header">
        <span class="cat__core__title col-md-6 text-uppercase mt-1">
            <strong>NOTIFICATIONS</strong>
        </span>
                <span class="col-md-6  col-sm-12 text-right">
                    <button type="button" class="btn btn-outline-primary btn1" (click)="deleteAllNotification()">delete all</button>
                    <button type="button" class="btn btn-outline-primary btn1" (click)="markNotificationStatusToReadByID(null, 'All')">mark all as read</button>
                </span>
    </div>

    <div class="card-block watermark p-0">
        <div class="mb-5">
            <div class="accordion" id="accordionSingle" *ngIf="getAllNotification==false">
                <div class="card" *ngFor="let notification of notificationObject;let indexCount=index">
                    <div class="card-header" role="tab" id="headingSingle" data-toggle="collapse" data-parent="#accordionSingle" data-target="#singleNotification"
                        aria-expanded="true" aria-controls="singleNotification">
                        <div class="card-title">
                            <span class="accordion-indicator pull-right">
                                        <i class="plus fa fa-plus"></i>
                                        <i class="minus fa fa-minus"></i>
                                    </span>
                            <h5 class="mb-0 mr-3 d-inline-block" style="color: #37669e;">
                                <strong>{{notification.Title}}</strong>
                            </h5>
                        </div>
                    </div>
                    <div id="singleNotification" class="card-collapse collapse show" role="tabcard" aria-labelledby="headingSingle" aria-expanded="true">
                        <div class="card-block">
                            <div [innerHTML]="notification.Description | safeHtml">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="accordionAll" *ngIf="getAllNotification==true" class="notifications-list-container">
                <div class="notification-item unRead" *ngFor="let unreadNotification of unreadNotificationList;let indexCountUnread=index">
                    <div class="notification-number">{{indexCountUnread+1}}</div>
                    <div class="notification-content" (click)="markNotificationStatusToReadByID(unreadNotification._id, 'One')">
                        <div class="notification-description" [innerHTML]="unreadNotification.Description | safeHtml"></div>
                    </div>
                    <div class="notification-actions">
                        <button type="button" class="btn-mark-read" (click)="markNotificationStatusToReadByID(unreadNotification._id, 'One')">Mark as Read</button>
                        <span class="notification-time">{{unreadNotification.CreatedDate | date:'hh:mm a'}}</span>
                    </div>
                </div>
                <div class="notification-item read" *ngFor="let readNotification of readNotificationsList;let indexCountRead=index">
                    <div class="notification-number">{{(unreadNotificationList?.length || 0) + indexCountRead + 1}}</div>
                    <div class="notification-content">
                        <div class="notification-description" [innerHTML]="readNotification.Description | safeHtml"></div>
                    </div>
                    <div class="notification-actions">
                        <button type="button" class="btn-delete" (click)="deleteNotificationByID(readNotification._id)">Delete</button>
                        <span class="notification-time">{{readNotification.CreatedDate | date:'hh:mm a'}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>